import { useCallback } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

const useNavigateWithSearch = () => {
  const history = useHistory();
  const { search: locationSearch } = useLocation();

  const navigateWithSearch = useCallback((pathname = '', search = {}, replace = false) => {
    if (!pathname) {
      return;
    }

    const query = new URLSearchParams(locationSearch);
    Object.entries(search).forEach(([key, value]) => {
      if (value === null || value === undefined) {
        query.delete(key);
      } else {
        query.set(key, value);
      }
    });

    if (replace) {
      history.replace({ pathname, search: query.toString() });
    } else {
      history.push({ pathname, search: query.toString() });
    }
  }, [history, locationSearch]);

  return navigateWithSearch;
};

export default useNavigateWithSearch;
